// extracted by mini-css-extract-plugin
var _1 = "CopilotMessageComposer-module__actions--RotQ1";
var _2 = "CopilotMessageComposer-module__actionsLeft--Y4B0C";
var _3 = "CopilotMessageComposer-module__actionsRight--sn8VN";
var _4 = "CopilotMessageComposer-module__animateUploadProgressBarWidth--GsPjQ";
var _5 = "CopilotMessageComposer-module__animatedBackground--W_Z1z";
var _6 = "CopilotMessageComposer-module__iconButton--jv0ts";
var _7 = "CopilotMessageComposer-module__inputContainer--gFOz2";
var _8 = "CopilotMessageComposer-module__messageComposer--rKbQb";
var _9 = "CopilotMessageComposer-module__selectableMenuItemCheckIcon--K8X7b";
var _a = "CopilotMessageComposer-module__selected--cL5QP";
var _b = "CopilotMessageComposer-module__stopButton--G_hgh";
export { _1 as "actions", _2 as "actionsLeft", _3 as "actionsRight", _4 as "animateUploadProgressBarWidth", _5 as "animatedBackground", _6 as "iconButton", _7 as "inputContainer", _8 as "messageComposer", _9 as "selectableMenuItemCheckIcon", _a as "selected", _b as "stopButton" }
